import React from "react";
import { Link } from "react-router-dom";
import FooterSection from "./FooterSection";

export default function LegalPageLayout({ pageTitle, effectiveDate, children }) {
  return (
    <div className="min-h-screen bg-brand-ivory text-brand-dark font-sans">
      {/* Compact Header */}
      <header className="bg-brand-ivory border-b border-brand-border py-4 px-4 md:px-6" data-testid="legal-page-header">
        <div className="max-w-[1000px] mx-auto flex items-center justify-between">
          <span className="font-display font-black uppercase text-sm md:text-base text-brand-dark tracking-wide">
            DEBT COLLECTOR KILL SWITCH
          </span>
          <Link
            to="/"
            data-testid="legal-back-to-home-link"
            className="font-sans font-bold text-xs md:text-sm text-brand-red hover:text-brand-cta-hover transition-colors whitespace-nowrap"
          >
            &larr; BACK TO HOME
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-[960px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <h1
          className="font-display font-black uppercase text-brand-dark tracking-tight text-2xl sm:text-3xl md:text-4xl leading-tight mb-2"
          data-testid="legal-page-title"
        >
          {pageTitle}
        </h1>
        <p className="font-sans text-brand-dark/60 text-sm mb-8" data-testid="legal-effective-date">
          Effective Date / Last Updated: {effectiveDate}
        </p>

        <div className="bg-card rounded-xl border border-brand-border shadow-sm p-5 sm:p-8 md:p-10 space-y-6" data-testid="legal-content-area">
          {children}
        </div>
      </main>

      <FooterSection />
    </div>
  );
}
